module.exports = __webpack_public_path__ + "static/img/search.5c2acba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search.png
// module id = p1AH
// module chunks = 1